import React from 'react'
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    TextField,
    IconButton,
    Paper,
    Checkbox,
    FormControl,
    TableCell,
    TableRow,
    FormControlLabel,
    Typography
} from '@mui/material/';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ListaDiagramas from '../ListaDiagramas';
import { auth, db } from '../../firebase/firebase';
import { arrayRemove, arrayUnion, doc, updateDoc } from 'firebase/firestore';
import { isElementOfType } from 'react-dom/test-utils';


const ModalAgregarDiagrama = (props) => {

    const {
        abrirModalAgregar, 
        handleCloseAgregar, 
        guardarInfo, 
        coleccion,
        setArrayDiagramas,
        diagramas,
        obtenerColecciones,
        nombreColeccion,
        obtenerDiagramas
    } = props;


    const user = auth.currentUser;

    // Funcion para actualizar diagramas en colección
    const handleSave = async() =>{
        await updateDoc(doc(db, 'colecciones', coleccion.id),{
            diagramas: coleccion.diagramas
        })

        handleCloseAgregar();
        obtenerColecciones();



        if(coleccion.diagramas.length > 0){
            /* console.log('Cole no vacía'); */

            diagramas.forEach((diagram)=>{
                /* console.log('------ Revisando diagrama '+diagram.titulo) */
                let encontrada = false;
                let existe = false;

                coleccion.diagramas.forEach((diagramaCole)=>{
                    if(diagram.idDocumento === diagramaCole.idDocumento){
                        if(!diagram.coleccion.includes(coleccion.nombre)){
                            //Agregar nombre de cole a arrelgo de cole en diagramas
                            encontrada = true;
                            /* console.log('Se debe agregar '+diagram.titulo+'a la cole'+coleccion.nombre) */
                        }
                        if(diagram.coleccion.includes(coleccion.nombre)){
                            /* console.log('Ya existe, no hacer nada') */
                            encontrada = true;
                            existe = true;
                        }
                    }
                })

                /* console.log('No se encontró coincidencias') */

                if(encontrada){
                    if(existe){
                        //No hacer nada
                    }else{
                        //Se actualiza
                        updateDoc(doc(db, user.uid, diagram.idDocumento),{
                            coleccion: arrayUnion(coleccion.nombre)
                        })
                    }
                    
                }else{
                    /* console.log('Como no se encuentra haremos algo') */
                    
                    if(diagram.coleccion.includes(coleccion.nombre) && !existe){
                        /* console.log('No está, pero tiene almacenada a la cole') */
                        updateDoc(doc(db, user.uid, diagram.idDocumento),{
                            coleccion: arrayRemove(coleccion.nombre)
                        })
                    }else{
                        /* console.log('No esta y no tiene almacenada a la cole') */
                    }
                }
                
                encontrada = false;
                existe = false;

            })
            
        }else{
            /* console.log('Cole vacia, quitar de diagramas') */
            diagramas.forEach((diagrama)=>{
                if(diagrama.coleccion.includes(coleccion.nombre)){
                    updateDoc(doc(db, user.uid, diagrama.idDocumento),{
                        coleccion: arrayRemove(coleccion.nombre)
                    })
                }
            })
        }

        
        obtenerColecciones();
        obtenerDiagramas();
        
    }


    return (
        <div>
            <Dialog
                open={abrirModalAgregar}
                onClose={handleCloseAgregar}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
            >
                <DialogContent>
                    <Typography
                        variant="h4"
                        align='center'
                        sx={{
                            marginBottom: '20px',
                            fontWeight: 'bold'
                        }}
                    >
                        {coleccion.nombre}
                    </Typography>
                    <ListaDiagramas
                        coleccion={coleccion}
                        agrega={true}
                        colection={true}
                        diagramas={diagramas}
                        arreglo={coleccion.diagramas}
                        obtenerColecciones={obtenerColecciones}
                        nombreColeccion={nombreColeccion}
                    />

                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseAgregar}>
                        Cerrar
                    </Button>
                    <Button onClick={handleSave}>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default ModalAgregarDiagrama